import { get, groupBy } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getStringArrayProp } from '@mews/fp';
import { createAction } from '@mews/framework';
import { Resource, ResourceStateUpdate } from '@mews-commander/resources';
import { ApplicationState, CommanderThunkAction } from '@mews-commander/types';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createScopedEntitiesReducer, createScopedBaseEntitySelectors } from './utils';
import { findResourcesChildrenIds } from './resourcesTree';

export const NAME = 'resources';

const RESOURCES_UPDATE = prefix('RESOURCES_UPDATE');

export const [getResources, getResourcesByIds, getResourcesByOwnerId, getResource] = createScopedBaseEntitySelectors<
    ApplicationState,
    Resource,
    typeof NAME,
    'enterpriseId'
>(parentSelector, NAME, 'enterpriseId');

export const setResources = (resources: $TSFixMe, enterpriseId: $TSFixMe) => (dispatch: $TSFixMe) =>
    dispatch(createAction(RESOURCES_UPDATE, resources, { scope: enterpriseId }));

export const getResourceName = createSelector(getResource, (resource) => resource?.name);

export const getResourceState = createSelector(getResource, (resource) => resource?.state);
export const getResourceStateReason = createSelector(getResource, (resource) => resource?.stateReason);
export const getResourceStateReasonClassification = createSelector(getResource, get('stateReasonClassification'));
export const resourcesReducer = createScopedEntitiesReducer({
    UPDATE_SUCCESS: RESOURCES_UPDATE,
});

export const getResourcesGroupedByParentId = createSelector(getResources, groupBy<Resource>('parentId'));

export const getResourcesChildrenIds = createSelector(
    getStringArrayProp('resourceIds'),
    getResourcesGroupedByParentId,
    findResourcesChildrenIds
);

export const modifyResourceStates =
    (updates: Array<ResourceStateUpdate>): CommanderThunkAction =>
    (dispatch, getState) => {
        const state = getState();
        const resourceIds = updates.map((update) => update.resourceId);
        const enterpriseId = getCurrentEnterpriseId();
        const resources = getResourcesByIds(state, { ids: resourceIds, enterpriseId });
        const newResources = resources.map((resource) => {
            const foundUpdate = updates.find((update) => update.resourceId === resource.id);
            if (!foundUpdate) return resource;

            const newResource = {
                ...resource,
                state: foundUpdate.state ?? resource.state,
                stateReason: foundUpdate.stateReason ?? resource.stateReason,
            };
            return newResource;
        });
        dispatch(setResources(newResources, enterpriseId));
    };
